import { render, staticRenderFns } from "./ManagementPurchasesCollect.vue?vue&type=template&id=03d007c0&scoped=true"
import script from "./ManagementPurchasesCollect.vue?vue&type=script&lang=js"
export * from "./ManagementPurchasesCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d007c0",
  null
  
)

export default component.exports